import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { copyToClipboard, docsCallExamples, DocsLang, stripHighlighting } from '../utils/docs-code';

const MAKING_A_CALL_EXAMPLE = {
  request: { question: 'What are the key announcements of Skanska for last 6 months?' },
  response: { comprehensiveness: 10 },
};

@Component({
  selector: 'app-docs-making-a-call',
  standalone: false,
  templateUrl: './docs-making-a-call.html',
})
export class DocsMakingACall {
  readonly languages: { id: DocsLang; label: string }[] = [
    { id: 'curl', label: 'cURL' },
    { id: 'javascript', label: 'JavaScript' },
    { id: 'python', label: 'Python' },
  ];

  private lang: DocsLang = 'curl';
  copied = false;

  constructor(private sanitizer: DomSanitizer) {}

  setLang(lang: DocsLang): void {
    this.lang = lang;
  }

  activeLang(): DocsLang {
    return this.lang;
  }

  get callExampleHtml(): SafeHtml {
    const examples = docsCallExamples('/api/rag', MAKING_A_CALL_EXAMPLE);
    return this.sanitizer.bypassSecurityTrustHtml(examples[this.lang]);
  }

  async copyCallExample(): Promise<void> {
    const examples = docsCallExamples('/api/rag', MAKING_A_CALL_EXAMPLE);
    if (!(await copyToClipboard(stripHighlighting(examples[this.lang])))) return;
    this.copied = true;
    setTimeout(() => { this.copied = false; }, 2000);
  }
}
